<loader *ngIf="loading"></loader>

<div *ngIf="!loading" class="rules-container">
  <div *ngIf="imageList.length == 0 && displayedElements.length == 0">
    <h2 *ngIf="!isSearchActive" class="images">
      <span>{{ "translate.general.noPageElements" | translate }}</span>
    </h2>
    <h2 *ngIf="isSearchActive" class="images">
      <span>{{ "translate.general.noResults" | translate }}</span>
    </h2>
  </div>
  <cat-doc-phrase-tile
  #phraseTiles
    *ngFor="let phrase of displayedElements; let i=index"
    [phrase]="phrase"
    [isFilterActive]="isFilterActive"
    (onTogglePhraseView)="onTogglePhraseViewClicked(phrase)"
    (onToggleRequestedPhrase)="onTogglePhraseViewClicked($event)"
    [displayPageNum]="displayPageNum"
    (onGoToPhrasePage)="onGoToPhrasePage(phrase)"
    (mouseenter)="onMouseEnter(phrase)"
    (mouseleave)="onMouseLeave(phrase)"
    [editable]="editable"
    [stateTag]="stateTag"
    [hasPrev]="hasPrevPhrase(i)"
    [hasNext]="hasNextPhrase(i)"
    (showNextIndElementEmitter)="showNextPhrase($event, i)"
    (showPrevIndElementEmitter)="showPrevPhrase($event, i)"
    (onUpdateSpellingIssues)="reloadData()"
    [referenceDocuments]="referenceDocuments"
  >
  <ng-template #childTemplate>
      <div class="childTemplate">
        <ng-container *ngFor="let child of phrase.children | keyvalue">
          <p-panel *ngIf="!['Footnotes', 'Tables'].includes(child.key)" [header]="child.key + ' (' + child.value.length +')'" [toggleable]="true" [collapsed]="true"
            [style]="{position: 'relative', top: '-1.5em'}">
            <cat-doc-phrase-tile  #phrasesChildren *ngFor="let childPhrase of child.value; let i1=index" 
              [phrase]="childPhrase"
              [isFilterActive]="isFilterActive" 
              [displayPageNum]="displayPageNum"
              [propagateActionFromParent]="phrase.propagateActionFromParent"
              [editable]="editable"
              [hasNext]="hasNextPhrase(i)"
              [hasPrev]="hasPrevPhrase(i)"
              [stateTag]="stateTag"
              (onTogglePhraseView)="onTogglePhraseViewClicked(childPhrase)"
              (onGoToPhrasePage)="onGoToPhrasePage(childPhrase)"
              (mouseenter)="onMouseEnter(childPhrase)" 
              (mouseleave)="onMouseLeave(childPhrase)"
              (showNextIndElementEmitter)="showNextPhrase($event, i)"
               (showPrevIndElementEmitter)="showPrevPhrase($event, i)"
              (onUpdateSpellingIssues)="reloadData()"
              [referenceDocuments]="referenceDocuments">
            </cat-doc-phrase-tile>
          </p-panel>
        </ng-container>
      </div>
  </ng-template>
  <ng-template #contentTemplate>
        <cat-doc-phrase-tile
          *ngFor="let contentPhrase of phrase.contentChildren"
          [phrase]="contentPhrase"    
          #phrasesContentChildren
          [isFilterActive]="isFilterActive"
          (onTogglePhraseView)="onTogglePhraseViewClicked(contentPhrase)"
          [displayPageNum]="displayPageNum"
          (onGoToPhrasePage)="onGoToPhrasePage(contentPhrase)"
          (mouseenter)="onMouseEnter(contentPhrase)"
          (mouseleave)="onMouseLeave(contentPhrase)"
          [editable]="editable"
          [stateTag]="stateTag"
          [propagateActionFromParent]="phrase.propagateActionFromParent"
          [hasPrev]="hasPrevPhrase(i)"
          [hasNext]="hasNextPhrase(i)"
          (showNextIndElementEmitter)="showNextPhrase($event, i)"
          (showPrevIndElementEmitter)="showPrevPhrase($event, i)"
          (onUpdateSpellingIssues)="reloadData()"
          [referenceDocuments]="referenceDocuments"
      >
      </cat-doc-phrase-tile>
  </ng-template>
  <ng-template #tablesTemplate>
      <cat-doc-phrase-tile
        #tablesChildren
          *ngFor="let childFootnote of phrase.children['Tables']"
          [phrase]="childFootnote"    
          [isFilterActive]="isFilterActive"
          (onTogglePhraseView)="onTogglePhraseViewClicked(childFootnote)"
          [displayPageNum]="displayPageNum"
          (onGoToPhrasePage)="onGoToPhrasePage(childFootnote)"
          (mouseenter)="onMouseEnter(childFootnote)"
          (mouseleave)="onMouseLeave(childFootnote)"
          [editable]="editable"
          [stateTag]="stateTag"
          [hasPrev]="hasPrevPhrase(i)"
          [hasNext]="hasNextPhrase(i)"
          [propagateActionFromParent]="phrase.propagateActionFromParent"
          (showNextIndElementEmitter)="showNextPhrase($event, i)"
          (showPrevIndElementEmitter)="showPrevPhrase($event, i)"
          (onUpdateSpellingIssues)="reloadData()"
          [referenceDocuments]="referenceDocuments"
      >
      </cat-doc-phrase-tile>
  </ng-template>
  <ng-template #imageTemplate>
        <cat-doc-phrase-tile
          *ngFor="let contentImage of phrase.imageChildren"
          [phrase]="contentImage"    
          #phrasesImageChildren
          [isFilterActive]="isFilterActive"
          (onTogglePhraseView)="onTogglePhraseViewClicked(contentImage)"
          [displayPageNum]="displayPageNum"
          (onGoToPhrasePage)="onGoToPhrasePage(contentImage)"
          (mouseenter)="onMouseEnter(contentImage)"
          (mouseleave)="onMouseLeave(contentImage)"
          [editable]="editable"
          [stateTag]="stateTag"
          [hasPrev]="hasPrevPhrase(i)"
          [hasNext]="hasNextPhrase(i)"
          [propagateActionFromParent]="phrase.propagateActionFromParent"
          (showNextIndElementEmitter)="showNextPhrase($event, i)"
          (showPrevIndElementEmitter)="showPrevPhrase($event, i)"
          (onUpdateSpellingIssues)="reloadData()"
          [referenceDocuments]="referenceDocuments"
      >
      </cat-doc-phrase-tile>
  </ng-template>
  <ng-template #footnotesTemplate>
      <cat-doc-phrase-tile
        #footnotesChildren
          *ngFor="let childFootnote of phrase.children['Footnotes']"
          [phrase]="childFootnote"    
          [isFilterActive]="isFilterActive"
          (onTogglePhraseView)="onTogglePhraseViewClicked(childFootnote)"
          [displayPageNum]="displayPageNum"
          (onGoToPhrasePage)="onGoToPhrasePage(childFootnote)"
          (mouseenter)="onMouseEnter(childFootnote)"
          (mouseleave)="onMouseLeave(childFootnote)"
          [editable]="editable"
          [stateTag]="stateTag"
          [hasPrev]="hasPrevPhrase(i)"
          [hasNext]="hasNextPhrase(i)"
          [propagateActionFromParent]="phrase.propagateActionFromParent"
          (showNextIndElementEmitter)="showNextPhrase($event, i)"
          (showPrevIndElementEmitter)="showPrevPhrase($event, i)"
          (onUpdateSpellingIssues)="reloadData()"
          [referenceDocuments]="referenceDocuments"
      >
      </cat-doc-phrase-tile>
  </ng-template>
</cat-doc-phrase-tile>

  <div *ngIf="imageList.length">
    <h2 class="images">
      <span>{{ "translate.general.images" | translate }}</span>
    </h2>
    <cat-doc-phrase-tile
    #imageTiles
      *ngFor="let img of imageList; let i = index"
      [phrase]="img"
      (onTogglePhraseView)="onTogglePhraseViewClicked(img)"
      [displayPageNum]="displayPageNum"
      (onGoToPhrasePage)="onGoToPhrasePage(img)"
      (mouseenter)="onMouseEnter(img)"
      (mouseleave)="onMouseLeave(img)"
      [editable]="editable"
      [stateTag]="stateTag"
      [hasNext]="hasNextImage(i)"
      [hasPrev]="hasPrevImage(i)"
      (onUpdateSpellingIssues)="reloadData()"
      (showNextIndElementEmitter)="showNextImage($event, i)"
      (showPrevIndElementEmitter)="showPrevImage($event, i)"
      [referenceDocuments]="referenceDocuments"
    ></cat-doc-phrase-tile>
  </div>
</div>
